import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { IconButton } from '@studio/legacy-components';
import { focusCursorToEndOfInput, pressedEnter } from 'utils/forms';

const ConfirmButton = styled(IconButton)`
  color: #05db99;
`;

class ManageTagOption extends Component {
  constructor(props) {
    super(props);

    this.focusAtEndOfEditTagInput = element => {
      if (!element) {
        return;
      }
      focusCursorToEndOfInput(element);
    };

    this.state = {
      updatedTagName: props.tag.name,
      showManagementOptions: false,
    };
  }

  hideManagementOptions = () => {
    this.setState({
      showManagementOptions: false,
    });
  };

  showManagementOptions = () => {
    this.setState({
      showManagementOptions: true,
    });
  };

  setUpdatedTagName = event => {
    const tagNameValue = event.target.value;
    this.setState({
      updatedTagName: tagNameValue,
    });
  };

  startEditingTag = () => {
    const { handleStartEditingTag, tag } = this.props;
    handleStartEditingTag(tag.id);
  };

  editTag = () => {
    const { tag, handleEditTag } = this.props;
    const { updatedTagName } = this.state;

    if (!handleEditTag) {
      return;
    }

    handleEditTag(tag.id, updatedTagName);
    this.stopEditingTag();
  };

  deleteTag = () => {
    const { handleDeleteTag, tag } = this.props;
    handleDeleteTag(tag);
  };

  stopEditingTag = () => {
    const { handleStartEditingTag } = this.props;
    handleStartEditingTag(null);
  };

  handleKeyPress = event => {
    if (pressedEnter(event)) {
      this.editTag();
    }
  };

  render() {
    const { updatedTagName, showManagementOptions } = this.state;
    const { className, tag, isEditingTag } = this.props;

    return (
      <div className={className}>
        {!isEditingTag && (
          <div
            className="manageTag"
            onMouseEnter={this.showManagementOptions}
            onMouseLeave={this.hideManagementOptions}
          >
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <div
              role="button"
              tabIndex={0}
              aria-label="Edit tag"
              className="tagName"
              onClick={this.startEditingTag}
            >
              {tag.name}
            </div>
            {showManagementOptions && (
              <>
                <IconButton
                  label="Edit tag"
                  icon="edit"
                  onClick={this.startEditingTag}
                />

                <IconButton
                  label="Delete tag"
                  icon="trash-alt"
                  onClick={this.deleteTag}
                />
              </>
            )}
          </div>
        )}
        {isEditingTag && (
          <div className="manageTag">
            <div className="tagName isEditingTag">
              <input
                ref={this.focusAtEndOfEditTagInput}
                value={updatedTagName || tag.name}
                onChange={this.setUpdatedTagName}
                onKeyPress={this.handleKeyPress}
              />
            </div>

            <ConfirmButton
              label="Edit tag"
              icon="check-circle"
              onClick={this.editTag}
            />

            <IconButton
              label="Close"
              icon={['far', 'times-circle']}
              onClick={this.stopEditingTag}
            />
          </div>
        )}
      </div>
    );
  }
}

ManageTagOption.propTypes = {
  handleDeleteTag: PropTypes.func.isRequired,
  handleEditTag: PropTypes.func.isRequired,
  handleStartEditingTag: PropTypes.func.isRequired,
  tag: PropTypes.object.isRequired,
  isEditingTag: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
};

export default styled(ManageTagOption)`
  .manageTag {
    display: flex;
    align-items: center;

    input {
      background: transparent;
      border: none;
      outline: none;
      color: #ffffff;
      width: 100%;
    }

    .tagName {
      border-radius: 20px;
      padding: 5px 8px;
      margin-right: 9px;
      background-color: #bac0ca;
      color: #ffffff;
      cursor: pointer;
      font-weight: 600;

      &.isEditingTag {
        display: inline-flex;
        flex-grow: 0.25;
      }
    }

    .manageTagOption {
      cursor: pointer;
      color: #7f8999;
      margin-right: 8px;
      font-weight: normal;
      font-size: 16px;
    }

    .confirmActionIcon {
      color: #05db99;
    }
  }
`;
